import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';
import Store from '~/types/Store';

export type StoresState = {
  readonly data: { [storeId: string]: Readonly<Store> };
  readonly allIds: readonly string[];
  readonly isLoaded: boolean;
  readonly isDisconnectingStore: boolean;
};

const initialState: StoresState = {
  data: {},
  allIds: [],
  isLoaded: false,
  isDisconnectingStore: false,
};

function reducer(state: StoresState = initialState, action: ActionTypes): StoresState {
  switch (action.type) {
    case ActionKeys.STORES_FETCH_SUCCESS:
      return {
        isDisconnectingStore: false,
        data: action.payload.stores.reduce(
          (obj, store: Store) => ({ ...obj, [store.objectId]: store }),
          {},
        ),
        allIds: action.payload.stores.map((store: Store) => store.objectId),
        isLoaded: true,
      };
    case ActionKeys.LEGACY_STORES_FETCH_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.stores.reduce(
            (obj, store: Store) => ({ ...obj, [store.objectId]: store }),
            {},
          ),
        },
        allIds: [...state.allIds, ...action.payload.stores.map((store: Store) => store.objectId)],
        isLoaded: true,
      };
    case ActionKeys.STORE_EDIT_SUCCESS:
      const key = action.payload.store.objectId;
      const store = state.data[key];
      return {
        ...state,
        data: {
          ...state.data,
          [key]: { ...store, ...action.payload.store },
        },
        isLoaded: true,
      };
    case ActionKeys.DISCONNECT_STORE:
      return {
        ...state,
        isDisconnectingStore: true,
      };
    case ActionKeys.DISCONNECT_STORE_SUCCESS:
    case ActionKeys.DISCONNECT_STORE_ERROR:
      return {
        ...state,
        isDisconnectingStore: false,
      };
    default:
      return state;
  }
}

export default reducer;
